import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-user-list-dialog',
  templateUrl: './user-list-dialog.component.html',
  styleUrls: ['./user-list-dialog.component.scss'],
})
export class UserListDialogComponent {
  filteredMembers$: Observable<string[]>;
  searchControl = new FormControl(null);

  constructor(private dialogRef: MatDialogRef<UserListDialogComponent>, @Inject(MAT_DIALOG_DATA) public datas: any) {
    this.filteredMembers$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.datas.filter(m => m.toLowerCase().includes(filterValue));
  }
}
